/**
 * Created by alvinoktavianus on 5/17/17.
 */

import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { currencyFormatter } from 'utils/formatter'
import { connect } from 'react-redux'

import { API_URL } from 'api/constants'
import Header from '../Header'
import styles from './BillingHistory.css'
import Download from 'assets/images/download.png'
import EmptyTable from 'assets/images/empty-table.png'
import LoadingSpinner from 'components/LoadingSpinner'

class BillingHistory extends Component {
  renderBillingTable () {
    const {billings} = this.props
    return _.map(billings, (billing) => {
      return (
        <tr key={billing.id}>
          <td>{moment(billing.created_at).format('DD MMM YYYY')}</td>
          <td className='visible-lg visible-md'>{billing.invoice_number}</td>
          <td className='visible-lg visible-md'>
            {moment(billing.start_period).format('DD MMM YYYY')} - {moment(billing.end_period).format('DD MMM YYYY')}
          </td>
          <td>
            <div>{currencyFormatter(billing.total_amount)}</div>
          </td>
          <td><span className={styles[billing.status]}>{billing.status}</span></td>
          <td className='visible-lg visible-md'>
            <input
              type='image'
              src={Download}
              className={styles['download-button']}
              value={billing.invoice_number}
              onClick={(e) => { this._downloadInvoice(e) }}
            />
          </td>
        </tr>
      )
    })
  }

  renderBillingHistory () {
    const {billings} = this.props
    if (billings.length !== 0) {
      return (
        <div className={`col-sm-12 ${styles['billing-history-table']}`}>
          <table className={`table ${styles['billing-history']}`}>
            <thead>
              <tr>
                <th>Invoice Date</th>
                <th className='visible-lg visible-md'>Invoice Number</th>
                <th className='visible-lg visible-md'>Period</th>
                <th>Total Amount</th>
                <th>Status</th>
                <th className='visible-lg visible-md'>Download Invoice</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBillingTable()}
            </tbody>
          </table>
        </div>
      )
    }
    return (
      <div className={styles['empty-table']}>
        <div>
          <img src={EmptyTable} />
        </div>
        <div>
          You don&#39;t have <br />any invoices yet
        </div>
      </div>
    )
  }

  render () {
    const {showLoadingSpinnerPage} = this.props
    return (
      <div className={styles['billing-history-wrapper']}>
        <div className={styles['billing-container']}>
          <div className='row'>
            <div className={!showLoadingSpinnerPage ? 'col-sm-12' : `col-sm-12 ${styles['load-header']}`}>
              <Header title='billing history' />
            </div>
          </div>
          <div className={`row ${styles['billing-list']}`}>
            {
              showLoadingSpinnerPage && <div className={`col-sm-12 ${styles['load-table']}`}>
                <div className={styles['loading-billing-history']}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
                </div>
              </div>
            }
            {
              !showLoadingSpinnerPage && this.renderBillingHistory()
            }
          </div>
        </div>
      </div>
    )
  }

  _downloadInvoice (event) {
    window.location.replace(API_URL + `/v1/billings/${event.target.value}.pdf`)
  }
}

const mapStateToProps = (state) => {
  const {billings} = state.setting.billing
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {billings, showLoadingSpinnerPage}
}

const mapDispatchToProps = (dispatch) => {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingHistory)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/BillingHistory/BillingHistory.js